var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPolygon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 24,
  viewBox: "0 0 21 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.259 6.53809V17.4609L10.8 22.9229L1.34106 17.4609V6.53809L10.8 1.07617L20.259 6.53809Z",
  stroke: "#D1D1D1"
})));
export { SvgPolygon as ReactComponent };
export default __webpack_public_path__ + "assets/f721b10b.svg";